import React, { MouseEventHandler } from 'react';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { Grid, GridItem } from '../../Grid';
import Icon from '../../Icon';
import {
  ButtonWrapper,
  Heading,
  IconWrapper,
  OrigamiBackground,
  StyledButtonLink,
  StyledGridItem,
  Subhead,
} from './styles';

export type HeroWithOrigamiBackgroundProps = {
  heading: string;
  subhead?: string;
  backButton?: { text: string; onClick?: MouseEventHandler; url: string };
} & ComponentProps;

const HeroWithOrigamiBackground: React.FC<HeroWithOrigamiBackgroundProps> = ({
  heading,
  subhead,
  backButton,
  ...props
}) => (
  <OrigamiBackground>
    <Grid alignLeft {...componentProps(props)}>
      {backButton && (
        <StyledGridItem desktop={10} tabletLandscape={10}>
          <StyledButtonLink onClick={backButton.onClick} href={backButton.url}>
            <ButtonWrapper>
              <IconWrapper>
                <Icon name="chevron" size="small" flipX />
              </IconWrapper>
              {backButton.text}
            </ButtonWrapper>
          </StyledButtonLink>
        </StyledGridItem>
      )}
      <GridItem desktop={6} tabletLandscape={6} tabletPortrait={6}>
        <Heading backButton={!!backButton}>{heading}</Heading>
        {subhead && <Subhead>{subhead}</Subhead>}
      </GridItem>
    </Grid>
  </OrigamiBackground>
);

export default applyComponentTheme(
  HeroWithOrigamiBackground,
  'HeroWithOrigamiBackground'
);
